import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArraysortPipe } from './arraysort.pipe';
import { FilterPipe } from './filter.pipe';
import { LinkifyPipe } from './linkify.pipe';
import { UnemojisPipe } from './unemojis.pipe';

@NgModule({
  declarations: [
    ArraysortPipe,
    FilterPipe,
    LinkifyPipe,
    UnemojisPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ArraysortPipe,
    FilterPipe,
    LinkifyPipe,
    UnemojisPipe,
  ]
})
export class PipesModule {}